module.exports = __webpack_public_path__ + "img/-.24260a96.svg";